import { render } from "./KontaktInfo.vue?vue&type=template&id=5edb5f6a&ts=true"
import script from "./KontaktInfo.vue?vue&type=script&lang=ts"
export * from "./KontaktInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__